module.exports = __webpack_public_path__ + "static/media/reliability.84770b6c.svg";